import * as React from 'react';

import { getTermsValue, NonEmptyArray } from '../../../../../JsonQuery';
import { ERepair } from '../../../../../api-models/common/json_query';
import { Repair } from '../../../components/advancedFilters/Repair';
import { useFiltersContext } from '../../../utils/useFiltersContext';

export const RepairContainer: React.FC = () => {
  const { jsonQuery, onChange } = useFiltersContext();
  const repair = getTermsValue('repair')(jsonQuery);

  const handleChange = React.useCallback(
    (repair: NonEmptyArray<ERepair> | null) => {
      onChange({ action: 'setRepair', arguments: [repair] });
    },
    [onChange],
  );

  return <Repair value={repair as NonEmptyArray<ERepair> | null} onChange={handleChange} />;
};
